import { range } from '@mobi/utils/array'

export const NAME_REGEX = /^[A-Z]+[A-Z '-]*[A-Z]+$/i

export const ALPHANUMERIC_REGEX = /[^a-z0-9]/gi

export const NUMERIC_REGEX = /[^0-9]/g

export const NAME_VALIDATION_MESSAGE =
  'Please enter a valid name, containing only letters, spaces, apostrophes, and hyphens.'
export const REQUIRED_VALIDATION_MESSAGE = 'This field is required.'
export const MEDICARE_CARD_NUMBER_VALIDATION_MESSAGE = 'Enter 10 digits only.'
export const MEDICARE_REFERENCE_NUMBER_VALIDATION_MESSAGE = 'Enter 1 digit only.'

export function getRequiredValidationMessage(value: string | null | undefined) {
  if (value === '' || value === null || value === undefined) return REQUIRED_VALIDATION_MESSAGE

  return ''
}

// Personal details validation

export function isValidName(name: string, allowBlank = false): boolean {
  if (!name) {
    return allowBlank
  }

  // Test against the regex and further ensure that there's a maximum of one apostrophe, one hyphen and one space.
  return (
    NAME_REGEX.test(name) &&
    name.indexOf("'") === name.lastIndexOf("'") &&
    name.indexOf('-') === name.lastIndexOf('-') &&
    name.indexOf(' ') === name.lastIndexOf(' ')
  )
}

export function getNameValidationMessage(name: string | null, allowBlank = false) {
  if (name === '' || name === null) return allowBlank ? '' : REQUIRED_VALIDATION_MESSAGE

  if (!isValidName(name, allowBlank)) return NAME_VALIDATION_MESSAGE

  return ''
}

export function isEmailValid(email: string) {
  const emailValidation =
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
  return emailValidation.test(email)
}

export function getEmailValidationMessage(enteredText: string) {
  if (enteredText === '') return REQUIRED_VALIDATION_MESSAGE

  if (!isEmailValid(enteredText)) {
    return 'Please enter a proper email address.'
  }

  return ''
}

export function getFormattedMobile(enteredText: string) {
  return enteredText.replace(/[\D]/gi, '')
}

export function isPhoneNumberValid(phone: string) {
  const phoneValidation = /^0[0-8]\d{8}$/
  return phoneValidation.test(phone)
}

export function getMobileValidationMessage(enteredText: string) {
  if (enteredText === '') return REQUIRED_VALIDATION_MESSAGE

  if (!isPhoneNumberValid(enteredText)) {
    return 'Please enter a valid Australian mobile number.'
  }

  return ''
}

// Medicare validation

export const medicareExpiryNext10Years = () => {
  const thisYear = new Date().getFullYear()
  return range(thisYear, thisYear + 10)
}

export function validateCardNumber(value: string | null | undefined) {
  if (!value) return REQUIRED_VALIDATION_MESSAGE
  if (!/^[0-9]{10}$/.test(value)) return MEDICARE_CARD_NUMBER_VALIDATION_MESSAGE
  return ''
}

export function validateReferenceNumber(value: string | null | undefined) {
  if (!value) return REQUIRED_VALIDATION_MESSAGE
  if (!/^[0-9]{1}$/.test(value)) return MEDICARE_REFERENCE_NUMBER_VALIDATION_MESSAGE
  return ''
}

export function validateExpiryDay(day: number | undefined, isGreenMedicareCardSelected: boolean) {
  return isGreenMedicareCardSelected ? '' : day == null ? REQUIRED_VALIDATION_MESSAGE : ''
}

// Deposit limit validation

export const DEPOSIT_LIMIT_MIN = 1
export const DEPOSIT_LIMIT_MAX = 99999
export const DEPOSIT_LIMIT_VALIDATION_MESSAGE = `Please enter a whole number between ${DEPOSIT_LIMIT_MIN} and ${DEPOSIT_LIMIT_MAX}.`

export function validateDepositLimitAmount(value: string): string {
  const num = Number(value)
  if (
    isNaN(num) ||
    !Number.isInteger(num) ||
    num < DEPOSIT_LIMIT_MIN ||
    num > DEPOSIT_LIMIT_MAX ||
    value === ''
  ) {
    return DEPOSIT_LIMIT_VALIDATION_MESSAGE
  }
  return ''
}
